import React from 'react';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import { grey } from '@material-ui/core/colors';
import { ListItem } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
// components
import Appbar from './Appbar';
import ChatItem from './ChatItem';
import ChatInput from './ChatInput';
import IntroCarousel from './IntroCarousel';
//models
import Message, { MessageDirection, MessageStatus, MessageType } from '../models/Message';
import Conversation, { Option } from '../models/Conversation';
import { errorMessage } from '../models/Constants';
//services
import { startConversation, sendMessage } from '../services/WatsonService';
import { parseMessageText, parseMessageTextLink, parseMessageOption, parseMessageCardCarousel } from '../services/ConversationParser';

export default class ChatArea extends React.Component <{closeHandler:any}, { inConversation: boolean, messages:Message[], conversation?: Conversation, showIntro?:boolean, elevateAppbar?:boolean }> { 
  //messagesEndRef:any = React.createRef(); //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  constructor(props:any) {
    super(props);
    this.state = {
      inConversation: false,
      messages: [],
      showIntro: true,
      elevateAppbar: false,
    };
  }

  
  

  componentDidMount(){
    if (!this.state.inConversation){
      startConversation()
        .then(conversation => {
          this.setState({conversation: (conversation as Conversation)!})
          this.addConversationToMessage((conversation as Conversation)!)
        })
        .catch(error => console.log(error));
    }
    //if(!this.state.showIntro) { this.scrollToBottom();} //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  }

  componentDidUpdate() {
    //if(!this.state.showIntro) { this.scrollToBottom();} //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  }

  scrollToBottom = () => {
    //this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });  //This was use to scroll to bottom. Removed as now message list is cleared on new message.
  }

  actions = {
    quickResponseHandler: (messageIndex:number, responseValue:any)=>{
      if(this.state.showIntro){
        this.setState({showIntro: false,  elevateAppbar: true});
      }
      const tempMessages = [...this.state.messages];
      const responseItemIndex:number = tempMessages.findIndex(msg => {
        return msg.messageIndex === messageIndex
      }); 

      const registeredResponseIndex:number = tempMessages[responseItemIndex].messageData.findIndex((opt:Option) => {
        return (opt.value).toLowerCase() === (responseValue as string).toLowerCase()
      })
      const registeredResponse:Option = {...tempMessages[responseItemIndex].messageData[registeredResponseIndex]} as Option
      
      const newMsg = {
        messageIndex:responseItemIndex,
        messageDirection:MessageDirection.SENT,
        messageStatus:MessageStatus.SENDING,
        messageType: MessageType.TEXT,
        messageData: registeredResponse.label
      }
      tempMessages[responseItemIndex] = newMsg;

      let conv:Conversation = {...this.state.conversation}
      sendMessage(newMsg.messageData, conv.context)
      .then(conversation => {
        const newConv: Conversation = conversation as Conversation;
        let lastSendingMsg: Message = tempMessages[tempMessages.length-1];
        lastSendingMsg.messageStatus = MessageStatus.SENT;
        tempMessages[tempMessages.length-1] = lastSendingMsg;
        this.setState({conversation: newConv, messages: tempMessages});
        this.addConversationToMessage(newConv);   
      })
      .catch(error => console.log(error));
    },

    sentMessageStatusHandler: () => {

    },

    chatInputSendHandler: (value:any) => {
      if(this.state.showIntro){
        this.setState({showIntro: false,  elevateAppbar: true});
      }
      const tempMessages = [...this.state.messages];
      const newMsg = {
        messageIndex: tempMessages.length,
        messageDirection:MessageDirection.SENT,
        messageStatus:MessageStatus.SENDING,
        messageType: MessageType.TEXT,
        messageData: value
      }
      tempMessages.push(newMsg);
      this.setState({messages: tempMessages});

      let conv:Conversation = {...this.state.conversation}
      sendMessage(newMsg.messageData, conv.context)
      .then(conversation => {
        const newConv: Conversation = conversation as Conversation;
        let lastSendingMsg: Message = tempMessages[tempMessages.length-1];
        lastSendingMsg.messageStatus = MessageStatus.SENT;
        tempMessages[tempMessages.length-1] = lastSendingMsg;
        this.setState({conversation: newConv, messages: tempMessages});
        this.addConversationToMessage((conversation as Conversation)!);
      })
      .catch(error => console.log(error));
    },


    
    // resetHandler: () => {
    //   this.setState({conversation: undefined, messages: []})

    //   startConversation()
    //     .then(conversation => {
    //       this.setState({conversation: (conversation as Conversation)!})
    //       this.addConversationToMessage((conversation as Conversation)!)
    //     })
    //     .catch(error => console.log(error));
    //   this.scrollToBottom();
    // },

    // closeHandler: () => {
    //   console.log("**** CLOSE HANDLER ****");
    // },

    introScrollCallback: (previousY:number, currentY:number) => {
      if(this.state.showIntro) {
        if(currentY > previousY) {
          this.setState({elevateAppbar: false})
        }
        else if(currentY < previousY) {
          this.setState({elevateAppbar: true})
        }
      }
    }

  }

  IntroComponent = () => {    
    if(!this.state.showIntro){
      return null
    }
    else {
      return <IntroCarousel scrollCallback = {this.actions.introScrollCallback} />
    }
  }

  render(){
    document.title = "ADI";
    return (
      <div style={{margin:0, padding:0, flexGrow:1, width:"100%", height:"100%"}}>
        <CssBaseline />
        <Appbar elevate = {this.state.elevateAppbar} /*resetHandler={this.actions.resetHandler} closeHandler={this.actions.closeHandler}*/
        conv={this.state.conversation} />
        <Box flexGrow={1}>     
          <this.IntroComponent />
        </Box>
        <Box flexGrow={1} marginBottom={8}>
          <List style={{color: grey[900], flexGrow:1, width:"100%", height:"100%"}}>
            {this.state.messages.map((message) => {
              return (
                <Box width={1}>
                  <ListItem key={message.messageIndex}>
                    <ChatItem itemIndex={message.messageIndex} message={message} actions={this.actions}/>
                  </ListItem>
                </Box>
              )
            })}  
            {/*<div ref={this.messagesEndRef} />  //This was use to scroll to bottom. Removed as now message list is cleared on new message.*/}
          </List>
        </Box>
        <div style={{height: 20}}></div>
        <ChatInput chatInputHandler={this.actions.chatInputSendHandler} />  
      </div>
      
    );
  }

  addConversationToMessage(conversation:Conversation){
    //const tempMessages = [...this.state.messages]; //comment this if uncommenting below logic.
    //logic to remove all previous message but 1, and clear screen. Last user input is kept.
    const tempMessages = [...this.state.messages].reverse();
    while (tempMessages.length > 1) {
      tempMessages.pop()
    }
    if(tempMessages.length > 0){
      const repMsg:Message = tempMessages[0];
      repMsg.messageIndex = 0;
      tempMessages[0] = repMsg;
    }
    //logic ends here

    let convIndex = 0;
    if(!conversation.context.display_option){
      conversation.context.display_option = ["undefined"];
    }
    conversation.context.display_option.forEach((dispopt:any) => {
      switch(dispopt){
        case "text":
          tempMessages.push(parseMessageText(conversation.genericResponses![convIndex],tempMessages.length));
          convIndex += 1;
          break;
        case "text_link":
          tempMessages.push(parseMessageTextLink(conversation.genericResponses![convIndex],tempMessages.length));
          convIndex += 1;
          break;
        case "option":
          parseMessageOption(conversation.genericResponses![convIndex],tempMessages.length).forEach(msg => {
            tempMessages.push(msg);
          });
          convIndex += 1;
          break;
        case "card_carousel":
          tempMessages.push(parseMessageCardCarousel(conversation.genericResponses!, convIndex, conversation.context.sba!.length,tempMessages.length));
          convIndex += conversation.context.sba!.length*2;
          break;
        case "undefined":default:
          tempMessages.push({
            messageData: errorMessage[Math.floor(Math.random() * errorMessage.length)],
            messageDirection: MessageDirection.RECEIVED,
            messageIndex: tempMessages.length,
            messageStatus: MessageStatus.RECEIVED,
            messageType: MessageType.TEXT
          } as Message);
          convIndex += 1;
          break;
      }
    });
    this.setState({messages: tempMessages});
  }
}